import { Typography, Tooltip, IconButton, } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import React, { useMemo } from 'react';
import { useCommonContext } from '../../hooks/useContexts';
import { renderOrderTotal } from './util/format';
import { separateReturnedFG } from '../../utils/returns/returns-fg-helper';
import { FeatureSwitches } from '../../constants/feature-switches';
var savingsText = function (hasProXtraSaving, customerType, hasPreferredDiscFlag) {
    if (hasProXtraSaving && customerType === 'b2b') {
        return (React.createElement("div", { className: "sui-flex sui-flex-col" },
            React.createElement(Typography, { "data-testid": "pro-xtra-savings-text" },
                "ProXtra Savings:",
                hasPreferredDiscFlag !== 'N' && (React.createElement(Typography, { "data-testid": "pro-xtra-preferred-pricing" }, "(Preferred Pricing Applied)")))));
    }
    return (React.createElement("div", { className: "sui-flex sui-flex-col" },
        React.createElement(Typography, null, "Savings:")));
};
export var OrderTotal = function (_a) {
    var _b, _c;
    var _d = _a.deliveryCharge, deliveryCharge = _d === void 0 ? 0 : _d, _e = _a.hasPreferredDiscFlag, hasPreferredDiscFlag = _e === void 0 ? 'N' : _e, _f = _a.hasProXtraSaving, hasProXtraSaving = _f === void 0 ? false : _f, _g = _a.orderDetailsData, _h = _g.grandTotalAmount, grandTotalAmount = _h === void 0 ? 0 : _h, _j = _g.subTotalAmount, subTotalAmount = _j === void 0 ? 0 : _j, _k = _g.taxTotalAmount, taxTotalAmount = _k === void 0 ? 0 : _k, _l = _g.otherDiscountAmount, otherDiscountAmount = _l === void 0 ? 0 : _l, _m = _g.returnTotal, returnTotal = _m === void 0 ? 0 : _m, statusDescription = _g.statusDescription, fulfillmentGroups = _g.fulfillmentGroups, _o = _a.shippingCharge, shippingCharge = _o === void 0 ? 0 : _o, customerType = _a.customerType, filteredFulfillmentObject = _a.filteredFulfillmentObject, militaryDiscount = _a.militaryDiscount, orderDetailsData = _a.orderDetailsData;
    var isMobile = useCommonContext().isMobile;
    var dataUnavailable = '---';
    var orderedGroups = useMemo(function () { return separateReturnedFG(filteredFulfillmentObject || []); }, [filteredFulfillmentObject]).orderedGroups;
    // checking if any item has returned description for the fullfillmentgroups
    var hasReturnedItemStatus = useMemo(function () {
        return orderedGroups === null || orderedGroups === void 0 ? void 0 : orderedGroups.some(function (group) {
            var _a;
            return (_a = group === null || group === void 0 ? void 0 : group.lineItems) === null || _a === void 0 ? void 0 : _a.some(function (item) { return (item === null || item === void 0 ? void 0 : item.statusDescription) === 'Returned'; });
        });
    }, [orderedGroups]);
    var isReturnComplete = statusDescription === 'Returned' || hasReturnedItemStatus;
    var validReturnTotal = Boolean(returnTotal) || grandTotalAmount < 0;
    // for BOPIS order no Shipping Label
    var currencyFormatter = function (price) {
        var money = 0;
        if (price === undefined || price === null)
            return dataUnavailable;
        if (price < 0) {
            money = price * -1;
        }
        else {
            money = price;
        }
        return money.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };
    var modifiedOtherDiscountAmount = function () {
        return otherDiscountAmount;
    };
    var renderEcoFee = function (_a) {
        var text = _a.text, amount = _a.amount, title = _a.title, label = _a.label;
        return (React.createElement("div", { className: "sui-flex sui-justify-between" },
            React.createElement(Typography, { className: "sui-text-base" },
                text,
                React.createElement(Tooltip, { placement: "bottom", title: title },
                    React.createElement(IconButton, { color: "info-strong", icon: InfoFilled, "aria-label": label, buttonSize: "tight" }))),
            React.createElement(Typography, { className: "sui-text-base", decoration: "line-through" },
                "$",
                currencyFormatter(amount))));
    };
    var renderLumberFee = function () {
        var lumberFee = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.lumberFee;
        if (!lumberFee)
            return null;
        return renderEcoFee({
            text: 'CA Lumber Fee:',
            amount: lumberFee,
            title: 'This transaction includes lumber, subject to an “eco fee” which is being paid on your behalf by The Home Depot.',
            label: 'Lumber Fee Information',
        });
    };
    var renderEmbeddedBattery = function () {
        var _a, _b;
        var embeddedBatteryFee = (_b = (_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.ecoFees) === null || _a === void 0 ? void 0 : _a.find(function (fee) { return fee.feeType === 'EMBEDDED_BATTERY_FEE'; })) === null || _b === void 0 ? void 0 : _b.amount;
        if (!embeddedBatteryFee || !FeatureSwitches.enableEmbeddedBatteryFee)
            return null;
        return renderEcoFee({
            text: 'CA Embedded Battery Fee:',
            amount: embeddedBatteryFee,
            title: 'This transaction includes an embedded battery, subject to an Embedded Battery Fee which is being paid on your behalf by The Home Depot.',
            label: 'Embedded Battery Fee Information',
        });
    };
    var renderMattressRecyclingFee = function () {
        var _a;
        var mattressRecyclingFee = (_a = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.mattressRecyclingFee) === null || _a === void 0 ? void 0 : _a.amount;
        if (!mattressRecyclingFee)
            return null;
        return renderEcoFee({
            text: 'Mattress Recycling Fee:',
            amount: mattressRecyclingFee,
            title: 'This transaction includes a mattress, subject to a Mattress Recycling Fee which is being paid on your behalf by The Home Depot.',
            label: 'Mattress Recycling Fee Information',
        });
    };
    return (React.createElement("div", { className: "sui-col-span-1 sui-order-3 md:sui-col-span-1  md:sui-order-2 ".concat(!isMobile ? 'sui-ml-12' : '') },
        React.createElement("div", { className: "sui-flex sui-flex-col lg:sui-gap-2 sm:sui-gap-1" },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { weight: "bold" }, "Subtotal:"),
                    React.createElement(Typography, { weight: "bold" },
                        "$",
                        currencyFormatter(subTotalAmount)),
                    ' '),
                (militaryDiscount === null || militaryDiscount === void 0 ? void 0 : militaryDiscount.chargeCategory) === 'DISCOUNT' &&
                    Number((_b = militaryDiscount === null || militaryDiscount === void 0 ? void 0 : militaryDiscount.chargeAmount) !== null && _b !== void 0 ? _b : '0') > 0 && (React.createElement("div", { className: "sui-text-success sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Military Discount:"),
                    React.createElement(Typography, null,
                        "-$", militaryDiscount === null || militaryDiscount === void 0 ? void 0 :
                        militaryDiscount.chargeAmount))),
                Boolean(modifiedOtherDiscountAmount()) && (React.createElement("div", { className: "sui-text-success sui-flex sui-justify-between" },
                    savingsText(hasProXtraSaving, customerType, hasPreferredDiscFlag),
                    React.createElement(Typography, { "data-testid": "pro-xtra-saving-value" },
                        "-$",
                        currencyFormatter(modifiedOtherDiscountAmount())))),
                (fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.find(function (item) {
                    return ['BuyOnlinePickupInStore', 'BuyOnlineShipToStore'].includes(item.fulfillmentType);
                })) ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { className: "sui-text-base" }, "Pickup:"),
                    React.createElement(Typography, { color: "success" }, "FREE"))) : null,
                (fulfillmentGroups === null || fulfillmentGroups === void 0 ? void 0 : fulfillmentGroups.find(function (item) {
                    return ![
                        'BuyOnlinePickupInStore',
                        'BuyOnlineShipToStore',
                        'InStorePurchase',
                        'InStore',
                    ].includes(item.fulfillmentType);
                })) ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { className: "sui-text-base" }, "Delivery:"),
                    shippingCharge + deliveryCharge > 0 ? (React.createElement(Typography, { "data-testid": "total-express-delivery" },
                        "$", (_c = (shippingCharge + deliveryCharge)) === null || _c === void 0 ? void 0 :
                        _c.toLocaleString('en-US', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        }))) : (React.createElement(Typography, { color: "success" }, "FREE")))) : null,
                renderMattressRecyclingFee(),
                renderLumberFee(),
                renderEmbeddedBattery(),
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Sales Tax:"),
                    React.createElement(Typography, null,
                        "$",
                        currencyFormatter(taxTotalAmount)),
                    ' '),
                !FeatureSwitches.enableRefundBreakdown &&
                    isReturnComplete &&
                    validReturnTotal ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Refund Total:"),
                    React.createElement(Typography, { "data-testid": "refund-total" }, returnTotal !== undefined || returnTotal !== null
                        ? "$".concat(currencyFormatter(returnTotal || grandTotalAmount))
                        : dataUnavailable))) : null,
                React.createElement("hr", null),
                React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, { weight: "bold" }, "Total:"),
                    React.createElement(Typography, { weight: "bold" }, "$".concat(renderOrderTotal(orderDetailsData)))),
                FeatureSwitches.enableRefundBreakdown &&
                    isReturnComplete &&
                    validReturnTotal ? (React.createElement("div", { className: "sui-flex sui-justify-between" },
                    React.createElement(Typography, null, "Refund Total:"),
                    React.createElement(Typography, { "data-testid": "refund-total" }, returnTotal !== undefined || returnTotal !== null
                        ? "$".concat(currencyFormatter(returnTotal || grandTotalAmount))
                        : dataUnavailable))) : null))));
};
